export default __webpack_public_path__ + "static/media/platform.ed774c09.svg";